/* eslint-disable @khan/frontend/require-stories -- TODO */
// eslint-disable-next-line no-restricted-imports -- TODO
import * as Perseus from "@khanacademy/perseus";
import type {PropsFor} from "@khanacademy/wonder-blocks-core";

import {PerseusI18nProviderWrapper} from "./perseus-i18n-provider-wrapper.tsx";

export const HintRenderer = (props: PropsFor<typeof Perseus.HintRenderer>) => (
    <PerseusI18nProviderWrapper>
        <Perseus.HintRenderer {...props} />
    </PerseusI18nProviderWrapper>
);
